// src/components/Skills.tsx
import React from "react";
import { Button } from "./Button";
import { SkillsCard } from "./SkillsCard";
import { skills } from "../data/skills";

interface SkillsProps {
  onBack: () => void;
}

export const Skills: React.FC<SkillsProps> = ({ onBack }) => {
  return (
    <div
      className="relative flex flex-col w-full h-screen bg-gradient-to-b from-teal-100 via-teal-50 to-white"
      style={{ paddingBottom: "80px" }}
    >
      <div className="sticky top-0 z-10 py-4 md:py-5 bg-teal-700 shadow-md">
        <h2 className="text-3xl md:text-4xl font-medium md:font-semibold text-center text-white text-shadow tracking-wide">
          Habilidades
        </h2>
      </div>

      <div className="flex flex-col md:flex-row gap-4 overflow-y-auto p-4 w-full max-w-5xl mx-auto flex-1">
        {skills.map((skill, idx) => (
          <SkillsCard idx={idx} title={skill.title} items={skill.items} />
        ))}
      </div>

      <div className="fixed bottom-4 w-full flex justify-center z-10">
        <Button onClick={onBack}>Volver</Button>
      </div>
    </div>
  );
};
